import { Card, Stack, Typography } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { coachupAction } from "redux/slice/coachup";
import ListingTable from "./ListingTable";

function AssignedToMe() {
  const dispatch = useDispatch();
  const assignedToMeArchive = useSelector((state) => state.coachup.assignedToMeArchive);
  const assignedToMeOpen = useSelector((state) => state.coachup.assignedToMeOpen);
  const [openReportsPaylaod, setOpenReportsPaylaod] = useState({
    searchBy: "",
    pageSize: 10,
    pageNumber: 0,
    reportStatuses: ["Open", "Ready For Review", "Draft"],
  });

  const [archiveReportsPaylaod, setArchiveReportsPaylaod] = useState({
    searchBy: "",
    pageSize: 10,
    pageNumber: 0,
    reportStatuses: ["Close"],
  });

  useEffect(() => {
    dispatch(coachupAction.getAssignedToMeOpenRequest(openReportsPaylaod));
  }, [openReportsPaylaod]);

  useEffect(() => {
    dispatch(coachupAction.getasAssignedToMeArchiveRequest(archiveReportsPaylaod));
  }, [archiveReportsPaylaod]);

  return (
    <MDBox mt={3}>
      <Card>
        <Stack>
          <MDTypography variant="h5" sx={{ px: 3, pt: 3, pb: 1 }}>
            Open
          </MDTypography>
          {assignedToMeOpen?.count > 0 ? (
            <ListingTable
              count={assignedToMeOpen?.count}
              reports={assignedToMeOpen?.data}
              payload={openReportsPaylaod}
              setPayload={setOpenReportsPaylaod}
              status="Open"
            />
          ) : (
            <Typography sx={{ p: "0 0 1rem 1.5rem", fontSize: "0.9rem", fontWeight: "400" }}>
              You have no Open reports
            </Typography>
          )}
        </Stack>
      </Card>
      <Card sx={{ mt: 3 }}>
        <Stack>
          <MDTypography variant="h5" sx={{ px: 3, pt: 3, pb: 1 }}>
            Archive
          </MDTypography>
          {assignedToMeArchive?.count > 0 ? (
            <ListingTable
              count={assignedToMeArchive?.count}
              reports={assignedToMeArchive?.data}
              payload={archiveReportsPaylaod}
              setPayload={setArchiveReportsPaylaod}
              status="Archive"
            />
          ) : (
            <Typography sx={{ p: "0 0 1rem 1.5rem", fontSize: "0.9rem", fontWeight: "400" }}>
              You have no Archive reports
            </Typography>
          )}
        </Stack>
      </Card>
    </MDBox>
  );
}

export default AssignedToMe;
